module.exports = {"title":"Туси на Руси","description":"Все интересные мероприятия от Калининграда до Владивостока. Сто поводов провести это лето в России","image":"https://lipton.afisha.ru/img/share-1.jpg","url":"https://lipton.afisha.ru/","shareurl":"https://lipton.afisha.ru/share.php","fbappid":1043130655827057,"GTM":"GTM-K24PNTJ"}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 329
// module chunks = 0